import React, { useEffect } from 'react'
import Link from 'next/link'
import Sign_up from '@/components/Auth/Signup'
import Head from 'next/head'
import { useRouter } from 'next/router'
import { getCookie } from 'cookies-next'
import { auth_cookie_name, base_url, default_site_url } from 'constant/url'
import Forgot_password from '@/components/Auth/Forgot_password'
import Reset_password from '@/components/Auth/Reset_password'
import { api_call } from '@/WebHandler/api_call'
import api_routes from '@/WebHandler/api_routes'
import axios from 'axios'

// import Header from '../partials/Header';

function Reset_pass({ isLoggedIn, isUniqIDAvailable, check_link }) {
  const router = useRouter()
  const redirect_url = router.query.to || default_site_url

  useEffect(() => {
    if (isUniqIDAvailable == false) {
      router.push('/')
    }
  }, [router])
  return (
    <>
      <Head>
        <meta
          key="twitter:title"
          name="twitter:title"
          content="Tradly – Bring your Dream into Reality. API-FIRST COMMERCE."
        />
        <meta
          key="og:title"
          property="og:title"
          content="Tradly – Bring your Dream into Reality. API-FIRST COMMERCE."
        />
        <title>Tradly - reset password</title>
      </Head>
      <div className="flex flex-col min-h-screen overflow-hidden">
        <main className="flex-grow">
          {isUniqIDAvailable && (
            <Reset_password
              isUniqIDAvailable={isUniqIDAvailable}
              check_link={check_link}
              isLoggedIn={isLoggedIn}
            />
          )}
        </main>
      </div>
    </>
  )
}

export default Reset_pass

export async function getServerSideProps({ req, res, query }) {
  // Pass data to the page via props
  const isLoggedIn = getCookie(auth_cookie_name, { req, res }) ? true : false
  const isUniqIDAvailable = query?.k ? query?.k : false

  const check_link = query?.k
    ? await axios({
        url: base_url + api_routes.check_reset_pass,
        method: 'POST',
        responseType: 'json',
        data: {
          unique_id: isUniqIDAvailable,
        },
      })
        .then((response) => {
          return response?.data?.data
        })
        .catch((error) => {
          console.log(error)
          return error?.response?.data?.error
        })
    : null

  return { props: { isLoggedIn, isUniqIDAvailable, check_link } }
}
